import PropTypes from 'prop-types';
import React from 'react';
import {
  Modal, Button,
} from 'react-bootstrap';
import diff from 'object-diff';
import { findById } from '../../../core/utils';
import HotelRoomPrefsForm from './HotelRoomPrefsForm';

class HotelRoomPrefsModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }
  handleSubmit(values) {
    const idx = this.props.tour.groups.findIndex(findById, values.group);
    if (idx === -1) {
      console.log('Can not find group... ', values.group);
      return;
    }
    const initialValues = this.props.tour.groups[idx].hotel_prefs;
    const changedValues = diff(initialValues, values);
    this.props.savePreferences(values.group, changedValues);
  }
  handleChange(value){

  }
  onBlur(value){

  }
  
  render() {
    let groups = this.props.tour.groups;
    //debugger;
    const prefData = [];
    // if(this.props.tour.groups.length){
    //   groups.map(group => prefData.push ({
    //     hotel_prefs: group.hotel_prefs,
    //     member_data: 
    //   })
    //   )
    // }
    //debugger
    // for(var i=0;i<this.props.tour.groups.length;i++){
    //   for(var j=0;j<this.props.tour.members.length;j++){
    //     if(this.props.tour.groups[i].name == this.props.tour.members[j].group.name){
    //        prefData.push({
    //         hotel_prefs_data: this.props.tour.groups[i].hotel_prefs,
    //         group_name: this.props.tour.groups[i].name,
    //         members_data: {
    //           value : this.props.tour.members[j].id,
    //           label: this.props.tour.members[j].first_name + ',' + this.props.tour.members[j].last_name
    //           //last_name: this.props.tour.members[j].last_name
    //         }
    //       })
    //     }
    //   }
    // }
    // let members_data = [
    //   { value: '1', label: 'Chocolatess' }
    // ]
     let members_data = [];
     let members_data_temp = [];
     function formatContactData(jsonObject) {
      return jsonObject.map(item => ({
        label: item.label,
        value: item.value,
      }));
    }
    //debugger
    for(var i=0;i<this.props.tour.groups.length;i++){
      for(var j=0;j<this.props.tour.members.length;j++){
        if(this.props.tour.groups[i].name == this.props.tour.members[j].group.name){
          members_data = members_data.concat({value : this.props.tour.members[j].id,label: this.props.tour.members[j].first_name + ',' + this.props.tour.members[j].last_name})
          
        }
      }
      members_data_temp = formatContactData(members_data)
      //debugger
      prefData.push({
        id: this.props.tour.groups[i].id,
        hotel_prefs: this.props.tour.groups[i].hotel_prefs,
        group_name: this.props.tour.groups[i].name,
        data:members_data_temp
      })
      members_data = []; 
    }

    //debugger
    //groups = groups.map(g => g.push({members:this.props.tour.members}))
    
    const searchPrefs = prefData.map(group =>
      <div key={group.id} className="col-sm-9">
        
        <h4 className="spacing">{group.group_name}</h4>
        <p>{group.members_count} members</p>
        <HotelRoomPrefsForm
          id={group.id}
          initialValues={group}
          onSubmit={this.handleSubmit}
          tour={this.props.tour}
          onChange={this.handleChange}
          onBlur={this.onBlur}
         // options = {this.props.tour.members}
        />
      </div>,
    );
    //debugger
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Hotel Room Preferences</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="panel">
              <div className="row">
                <div className="col-sm-9">Please enter the number and type of rooms you need.</div>
                {searchPrefs}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer><Button bsStyle="info" onClick={this.props.onClose}>Close</Button></Modal.Footer>
        </Modal>
      </div>
    );
  }
}


HotelRoomPrefsModal.propTypes = {
  tour: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  savePreferences: PropTypes.func.isRequired,
};

export default HotelRoomPrefsModal;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelRoomPrefsModal.js